import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { history } from '../../state/store';

import Button from '../form/Button';
import Message from '../form/Message';
import UserApi from '../../api/user';
import OrganizationApi from '../../api/organization';

// React 16.8 Hooks attempt
// export default function NewTeamMemberPage(props) {
//     const [name, setName] = useState("")
//     const [email, setEmail] = useState("")
//     const [role, setRole] = useState("")

//     function onChangeName(e) {
//         setName(e.target.value)
//     }

//     function onChangeEmail(e) {
//         setEmail(e.target.value)
//     }

//     function onChangeRole(e) {
//         setRole(e.target.value)
//     }

//     return (
//         <div>
//             <Message info={this.state.message} />
//             <form onSubmit={this.onFormSubmit}>
//                 <h2>Add New Organization Member</h2>
//                 <div className="form__field">
//                     <label htmlFor="name">Name: </label>
//                     <input type="text" name="name" value={this.state.name} onChange={this.onChangeName} />
//                 </div>
//                 <div className="form__field">
//                     <label htmlFor="email">Email: </label>
//                     <input type="text" name="email" value={this.state.email} onChange={this.onChangeEmail} />
//                 </div>
//                 <div className="form__field">
//                     <label>Role: </label>
//                     <Select name="role"
//                         value={this.state.role}
//                         options={this.state.roles}
//                         onChange={this.onChangeRole}
//                         clearable={false}
//                         searchable={false} />
//                 </div>
//                 <div className="form__field">
//                     <label>Practice</label>
//                     <Select name="practices"
//                         options={this.state.practices}
//                         value={this.state.rVal}
//                         //value={this.state.practices[0]}
//                         onChange={this.onChangeResource}
//                         //onChange={e => this.changePractice(mem, e)}
//                         clearable={false}
//                         searchable={false} />
//                 </div>
//                 <div className="form__buttons">
//                     <Button type="submit" defaultText="Save" busyText="Inviting User" />
//                     <Link to='' onClick={this.goBack}>Cancel</Link>
//                 </div>

//             </form>
//         </div>
//     );

// }
export default class NewTeamMemberPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            roles: [],
            name: '',
            email: '',
            role: '',
            message: '',
            resource: '',
            practices: [],
            orgId: '',
            rVal: '',
        };

        this.getRoles = this.getRoles.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeRole = this.onChangeRole.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
        this.getPractices = this.getPractices.bind(this);
        this.onChangeResource = this.onChangeResource.bind(this);
    }

    componentDidMount() {
        this.getRoles();
        this.getPractices();
        this.setState({
            orgId: this.props.organizationId,
        });
    }

    getRoles() {
        UserApi.listRoles()
            .then(roles => {
                roles = roles.map(role => {
                    return { value: role, label: role };
                });
                this.setState({ roles: roles });
            })
            .catch(err => {
                console.log('New member get roles error', err);
            });
    }

    onChangeName(e) {
        this.setState({
            name: e.target.value,
        });
        // TODO -- look up users
    }

    onChangeEmail(e) {
        this.setState({
            email: e.target.value,
        });
    }

    onChangeRole(e) {
        this.setState({
            role: e.value,
        });
    }

    onChangeResource(e) {
        //TODO -- change e.value to the actual resource being pulled
        let rtv = `practice:${e.value}`;
        this.setState({
            rVal: e.value,
        });

        if (e.value === '*') {
            rtv = `organization:${this.props.organizationId}`;
        }
        console.log(rtv);
        this.setState({
            resource: rtv,
        });
    }

    goBack() {
        history.goBack();
    }

    getPractices() {
        OrganizationApi.getPractices(this.props.organizationId)
            .then(practices => {
                practices = practices.map(practice => {
                    return { value: practice.id, label: practice.name };
                });
                practices.unshift({ value: '*', label: 'All' });
                this.setState({ practices: practices });
            })
            .catch(errorMessage => {
                console.log('Error: ' + errorMessage);
            });
    }
    onFormSubmit(event) {
        event.preventDefault();
        // TODO: Kick off create member
        // Invite OR Select?
        UserApi.invite(
            this.state.email.toString().toLowerCase(),
            this.state.name,
            this.state.resource,
            this.state.role,
            this.props.organizationId.toString()
        );

        this.setState({
            message: `Invited user ${
                this.state.name
            } at email: ${this.state.email
                .toString()
                .toLowerCase()} with role: ${this.state.role}`,
        });
    }

    render() {
        return (
            <div>
                <Message info={this.state.message} />
                <form onSubmit={this.onFormSubmit}>
                    <h2>Add New Organization Member</h2>
                    <div className="form__field">
                        <label htmlFor="name">Name: </label>
                        <input
                            type="text"
                            name="name"
                            value={this.state.name}
                            onChange={this.onChangeName}
                        />
                    </div>
                    <div className="form__field">
                        <label htmlFor="email">Email: </label>
                        <input
                            type="text"
                            name="email"
                            value={this.state.email}
                            onChange={this.onChangeEmail}
                        />
                    </div>
                    <div className="form__field">
                        <label>Role: </label>
                        <Select
                            name="role"
                            value={this.state.role}
                            options={this.state.roles}
                            onChange={this.onChangeRole}
                            clearable={false}
                            searchable={false}
                        />
                    </div>
                    <div className="form__field">
                        <label>Practice</label>
                        <Select
                            name="practices"
                            options={this.state.practices}
                            value={this.state.rVal}
                            //value={this.state.practices[0]}
                            onChange={this.onChangeResource}
                            //onChange={e => this.changePractice(mem, e)}
                            clearable={false}
                            searchable={false}
                        />
                    </div>
                    <div className="form__buttons">
                        <Button
                            type="submit"
                            defaultText="Save"
                            busyText="Inviting User"
                        />
                        <Link to="" onClick={this.goBack}>
                            Cancel
                        </Link>
                    </div>
                </form>
            </div>
        );
    }
}
